"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bcp47LanguageTagSchema = exports.languageISO3Schema = exports.languageISO1Schema = void 0;
const zod_1 = require("zod");
// @link https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
exports.languageISO1Schema = zod_1.z.enum(["en", "pt", "es"]);
// @Link https://en.wikipedia.org/wiki/List_of_ISO_639_language_codes
exports.languageISO3Schema = zod_1.z.enum(["eng", "por"]);
// @link https://en.wikipedia.org/wiki/IETF_language_tag
exports.bcp47LanguageTagSchema = zod_1.z.enum([
    "en-US",
    "pt-BR",
    "es-ES",
    "en-GB",
]);
//# sourceMappingURL=language.js.map